import { useEffect, useState } from "react";
import RightTimeApi from "@/API";
import "@style/Admin.scss";
import Enums from "@/enums";
import { toast } from "react-toastify";
import { MdEdit, MdDelete, MdAdd, MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { FaPlusSquare } from "react-icons/fa";
import CompanyFeeItemModal from '@modals/CompanyFeeItemModal';


// Billable Items Tab
export default function CompanyBillableItemsTab(props) {
  const { updateSpinner, updateAccountingData, activeSubTab, tabData } = props;

  const [billableItems, setBillableItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  if(activeSubTab!=="fees") return null;
  useEffect(() => {
    if (tabData && tabData.company && tabData.company.id) {
      updateSpinner && updateSpinner(true);
      RightTimeApi.getAsync("/Company/" + tabData.company.id + "/FeeSchedule")
        .then(resp => {
          if (resp && resp.ok && resp.jsonData) 
            setBillableItems(resp.jsonData);
          else toast.error("Failed to load billable items");
        })
        .catch(err => toast.error("Error loading billable items: " + err.message))
        .finally(() => updateSpinner && updateSpinner(false));
    }
  }, [tabData.company, updateSpinner]);
  function formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0);
  }
  function handleAddItem() {
    setEditingItem(null);
    setIsModalOpen(true);
  }
  function handleEditItem(item) {
    setEditingItem(item);
    setIsModalOpen(true);
  }
  function handleCloseModal() {
    setIsModalOpen(false);
    setEditingItem(null);
  }

  function handleModalSave() {
    // Refresh the data after save
    if (tabData.company && tabData.company.id) {
      updateSpinner && updateSpinner(true);
      RightTimeApi.getAsync("/Company/" + tabData.company.id + "/FeeSchedule")
        .then(resp => {
          if (resp && resp.ok && resp.jsonData) 
            setBillableItems(resp.jsonData);
          else toast.error("Failed to load billable items");
        })
        .catch(err => toast.error("Error loading billable items: " + err.message))
        .finally(() => updateSpinner && updateSpinner(false));
    }
    
    // Also update the parent data if callback is available
    if(props.updateAccountingData) props.updateAccountingData();
  }

  async function toggleGlobalFee(feeScheduleItemId) {
    if (!tabData || !tabData.company || !tabData.company.id) return;
    
    updateSpinner && updateSpinner(true);
    try {
      const response = await RightTimeApi.putAsync(`Company/${tabData.company.id}/FeeToggle/${feeScheduleItemId}`, "POST");
      if (response && response.ok) {
        toast.success("Fee toggle updated successfully");
        if(props.updateAccountingData) props.updateAccountingData();
      } else {
        toast.error("Failed to toggle fee");
      }
    } catch (error) {
      console.error("Error toggling fee:", error);
      toast.error("Error toggling fee: " + error.message);
    } finally {
      updateSpinner && updateSpinner(false);
    }
  }

                      
  let companyFeeItems = props.billingData.companyFeeItems.filter(bi => bi.active);
  // Save and delete logic would be implemented here as needed
  return (
    <div className="horizontal">
      <div className="tableWrapper factTable scrollable">
        <table>
          <caption>
            <span className="title">Company Fee Schedule</span>
            <FaPlusSquare className="actionIcon plusIcon floatRight" onClick={handleAddItem} title="Add New Billable Item" />
          </caption>
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Rate</th>
            </tr>
          </thead>
          <tbody>
            {companyFeeItems.length > 0 ? (
              companyFeeItems.map((item) => (
                <tr key={item.id} onClick={() => handleEditItem(item)} className="clickable">
                  <td>{item.itemName}</td>
                  <td className="right">{formatCurrency(item.amount)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="center">No billable items found</td>
            </tr>
          )}
          </tbody>
            </table>
      </div>
      <div className="tableWrapper factTable scrollable">
        <table>
          <caption>
            <span className="title">Global Fee Schedule</span>
          </caption>
          <thead>
            <tr>
              <th></th>
              <th>Item Name</th>
              <th>Rate</th>
            </tr>
          </thead>
          <tbody>
            {props?.billingData?.feeSchedule?.items && props?.billingData?.feeSchedule?.items.length > 0 ? (
              props.billingData.feeSchedule.items.map((item) => (
                <tr key={item.id}>
                  <td data-fee-id={item.id} onClick={() => toggleGlobalFee(item.id)} className="clickable">
                    {props.billingData.companyFeeItems
                      .some(bi => bi.feeScheduleItemId === item.id && bi.active) ?
                      <MdCheckBox className="checkbox checked actionIcon" />:
                      <MdCheckBoxOutlineBlank className="checkbox unchecked actionIcon" />
                    }
                    </td>
                  <td>{item.itemName}</td>
                  <td className="right">{formatCurrency(item.amount)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="center">No billable items found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      
      <CompanyFeeItemModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        editingItem={editingItem}
        company={tabData.company}
        onSave={handleModalSave}
      />
    </div>
  );
}

